/**
 * Input Mixin
 * @desc Handles logic for AppInputs and updating the state
 */
export default {
  // Methods
  methods: {
    /**
     * Handle Input / Click
     */
    $_input_updateState (actionName, value) {
      this.$store.dispatch(actionName, value)
    }
  }
}
